import GenericRequest, { METHOD_POST } from '../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../shared/webservices/endpoint';

export default class MonthsRequest extends GenericRequest {

    constructionId;
    year;

    constructor(constructionId = null, year = null) {
        super(METHOD_POST, ApiEndpoints.MONTLY_MONTHS);

        this.constructionId = constructionId;
        this.year = year;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.constructionId ) request.criteria.construction_id = this.constructionId;
        if ( this.year ) request.criteria.year = this.year;
        return request;
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/ws/MonthsRequest.js